import { truncateString } from "@/utils/truncateString";
import styles from "./Card.module.css";
import { ClothingItem } from "@/types/product";
import { useImageLoading } from "@/hooks/useImageLoading";

import EmptyProduct from "../../assets/emptyProduct.svg";

interface GridCardProps {
  item: ClothingItem;
  showMemberBadge?: boolean;
  onClick?: () => void;
}

export function GridCard({ item, onClick }: GridCardProps) {
  const productImage = item.product_images[0];
  const { imageURI, handleImageLoad } = useImageLoading(productImage?.image);

  const hasImages = item && item?.product_images?.length > 0;

  return (
    <div className={styles.gridCard} onClick={onClick}>
      <div className={styles.gridImage}>
        {/* <span className={styles.gridEmoji}>{item.emoji}</span> */}
        {/* {showMemberBadge && memberName && <span className={styles.badge}>{memberName}</span>} */}
        <img
          className={styles.gridImageContent}
          src={hasImages ? (imageURI as string) : EmptyProduct}
          onLoad={handleImageLoad}
        />
      </div>
      <div className={styles.gridInfo}>
        <div className={styles.brand}>{item.brand.name}</div>
        <div className={styles.productName}>{truncateString(item.name, 65)}</div>
        <div className={styles.gridRow}>
          <span className={styles.price}>${formatPrice(Number(item.price_paid))}</span>
          <span className={styles.date}>{formatDateToYYYYMMDD(new Date(item.purchased_at || ""))}</span>
        </div>
      </div>
    </div>
  );
}

function formatPrice(price: number): string {
  return price.toLocaleString("en-US", {
    minimumFractionDigits: price % 1 ? 2 : 0
  });
}

function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
